<div class="audit-log-undo-review-check-dialog tw-pt-8">
    <form #form="ngForm">
        <label for="audit-comment" class="tw-sr-only">{{ 'adminAuditLog.dialog.undoReviewCheck.placeholder' | transloco }}</label>
        <input pInputText type="text" [(ngModel)]="comment" id="audit-comment" name="comment" fluid class="tw-mb-4" [placeholder]="'adminAuditLog.dialog.undoReviewCheck.placeholder' | transloco"/>
    </form>
    <div class="tw-flex tw-justify-end">
        <p-button 
            class="tw-mr-4"
            [label]="'adminAuditLog.dialog.undoReviewCheck.buttonLabel.cancel' | transloco"
            severity="secondary"
            variant="text"
            (onClick)="dialogRef.close()"
        />
        <p-button 
            [label]="'adminAuditLog.dialog.undoReviewCheck.buttonLabel.save' | transloco"
            severity="primary"
            [disabled]="form.invalid"
            (onClick)="submitComment()"
        />
    </div>
</div>